import {
  CLEAR_INDIVIDUAL_COLLECTOR,
  GET_COLLECTOR_SUCCESS,
  GET_INDIVIDUAL_COLLECTOR,
} from "../actions/collector";

const initialState = {
  collectorData: [],
  individualCollector: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COLLECTOR_SUCCESS:
      return { ...state, collectorData: action.payload };

    case GET_INDIVIDUAL_COLLECTOR:
      return { ...state, individualCollector: action.payload };

    case CLEAR_INDIVIDUAL_COLLECTOR:
      return { ...state, individualCollector: {} };
    default:
      return state;
  }
};
